// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qhjr","type":"styles_type__2aSx6","choices":"styles_choices__2ys0N"};